import { Controller } from '@hotwired/stimulus';
/*
 * Description
 * -------
 *
 * Removes data-unrevealed attribute from element.
 *
 * Can be used on any element.
 * Can be used multiple times in the document.
 *
 * Usage
 * -------
 *
 * <span
 *   data-unrevealed
 *   data-controller="spoiler"
 *   data-action="click->spoiler#reveal"
 * >
 *   Spoiler text
 * </span>
 */
export class Spoiler extends Controller {
    reveal() {
        delete this.element.dataset.unrevealed;
    }
}
